// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3x1Z8","info":"PatientInfo_info__1ZYnp"};